/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exit_ApplicationInputs */

const en_exit_application = /** @type {(inputs: Exit_ApplicationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exit application`)
};

const fr_exit_application = /** @type {(inputs: Exit_ApplicationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quitter l'application`)
};

const de_exit_application = /** @type {(inputs: Exit_ApplicationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anwendung verlassen`)
};

const it_exit_application = /** @type {(inputs: Exit_ApplicationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esci dall'applicazione`)
};

const ru_exit_application = /** @type {(inputs: Exit_ApplicationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Заявление о выходе`)
};

const es_exit_application = /** @type {(inputs: Exit_ApplicationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salir de la aplicación`)
};

const zh_cn2_exit_application = /** @type {(inputs: Exit_ApplicationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`退出应用程序`)
};

const ja_exit_application = /** @type {(inputs: Exit_ApplicationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アプリケーションを終了する`)
};

const hi_exit_application = /** @type {(inputs: Exit_ApplicationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`छोड़ने के लिए प्रार्थनापत्र`)
};

const pt_pt2_exit_application = /** @type {(inputs: Exit_ApplicationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sair do aplicativo`)
};

/**
* | output |
* | --- |
* | "Exit application" |
*
* @param {Exit_ApplicationInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const exit_application = /** @type {((inputs?: Exit_ApplicationInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exit_ApplicationInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_exit_application(inputs)
	if (locale === "de") return de_exit_application(inputs)
	if (locale === "it") return it_exit_application(inputs)
	if (locale === "ru") return ru_exit_application(inputs)
	if (locale === "es") return es_exit_application(inputs)
	if (locale === "zh-CN") return zh_cn2_exit_application(inputs)
	if (locale === "ja") return ja_exit_application(inputs)
	if (locale === "hi") return hi_exit_application(inputs)
	if (locale === "pt-PT") return pt_pt2_exit_application(inputs)
	return en_exit_application(inputs)
});